angular.module('tradersyard').component('tyLoadingSpinner', {
    template: `
        <div class="preview-loader-css" style="transform:scale(0.6)">
            <div>
                <div></div>
                <div></div>
            </div>
        </div>
    `,
});

export {};
